import { render, staticRenderFns } from "./ControllerProcess.vue?vue&type=template&id=6f5e5c4d&scoped=true&"
import script from "./ControllerProcess.vue?vue&type=script&lang=js&"
export * from "./ControllerProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5e5c4d",
  null
  
)

export default component.exports